export interface UnenrollmentReasonOption {
  text: string
  value: string
}

export const BatteryReasons: UnenrollmentReasonOption[] = [
  {
    text: 'Exporting to grid during peak times',
    value: 'exporting_to_grid_during_peak_times',
  },
  {
    text: 'Overriding existing schedule',
    value: 'overriding_existing_schedule',
  },
  {
    text: 'Other',
    value: 'other',
  },
]

export const ChargerReasons: UnenrollmentReasonOption[] = [
  {
    text: 'Not charging to limit',
    value: 'not_charging_to_limit',
  },
  {
    text: 'Charging during peak times',
    value: 'charging_during_peak_times',
  },
  {
    text: 'Overriding existing schedule',
    value: 'overriding_existing_schedule',
  },
  {
    text: 'Other',
    value: 'other',
  },
]

export const ThermostatReasons: UnenrollmentReasonOption[] = [
  {
    text: "It's too hot/too cold",
    value: 'too_hot_cold',
  },
  {
    text: 'Temperature adjustments too frequent',
    value: 'temperature_adjustments_too_frequent',
  },
  {
    text: 'Unexpected adjustments',
    value: 'unexpected_adjustments',
  },
  {
    text: 'Other',
    value: 'other',
  },
]

export const VehicleReasons: UnenrollmentReasonOption[] = [
  {
    text: 'Not charging to limit',
    value: 'not_charging_to_limit',
  },
  {
    text: 'Charging during peak times',
    value: 'charging_during_peak_times',
  },
  {
    text: 'Overriding existing schedule',
    value: 'overriding_existing_schedule',
  },
  {
    text: 'Other',
    value: 'other',
  },
]

export const ProgramReasons: (UnenrollmentReasonOption & {
  requiresIncentivesOnProgram?: boolean
})[] = [
  {
    text: 'Never received rewards',
    value: 'never_received_rewards',
    requiresIncentivesOnProgram: true,
  },
  {
    text: 'Lost control over devices',
    value: 'lost_control_over_devices',
  },
  {
    text: "Program wasn't clear or valuable to me",
    value: 'program_not_clear_or_valuable',
  },
  {
    text: 'Security/privacy concerns',
    value: 'security_privacy_concerns',
  },
  {
    text: 'Other',
    value: 'other',
  },
]

// Combined list of all unique reasons for the survey builder
export const AllUnenrollmentReasons: UnenrollmentReasonOption[] = [
  ...BatteryReasons,
  ...ChargerReasons,
  ...ThermostatReasons,
  ...VehicleReasons,
  ...ProgramReasons,
].reduce(
  (unique: UnenrollmentReasonOption[], reason: UnenrollmentReasonOption) => {
    if (!unique.find((r) => r.value === reason.value)) {
      unique.push(reason)
    }
    return unique
  },
  [] as UnenrollmentReasonOption[],
)
